import { Link, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth.js';
import { RepoOverview } from './routes/repo-overview.js';
import { VelocityScorecard } from './routes/velocity-scorecard.js';
import { CostView } from './routes/cost.js';
import { RepoDashboard } from './routes/repo-dashboard.js';
import { PrDetail } from './routes/pr-detail.js';
import { WeeklyDigest } from './routes/weekly-digest.js';
import { PolicyVersions } from './routes/policy-versions.js';
import { Suppressions } from './routes/suppressions.js';

export function App() {
  const { idToken, email, signIn, signOut, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-gray-500">Loading...</div>
      </div>
    );
  }

  if (!idToken) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="mx-auto mt-[15vh] max-w-sm rounded-md border border-gray-300 bg-white px-8 py-10 text-center shadow-[0_1px_3px_rgba(0,0,0,0.04),_0_4px_12px_rgba(0,0,0,0.04)]">
          <h1 className="mb-2 text-2xl font-bold tracking-tight text-gray-900">Death Star</h1>
          <p className="mb-6 text-sm text-gray-500">Diff Vader observability portal</p>
          <button
            onClick={signIn}
            className="inline-flex items-center gap-3 rounded border border-gray-300 bg-white px-5 py-2 text-sm font-medium text-gray-800 transition hover:bg-gray-50 hover:shadow-sm"
          >
            <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
              <path fill="#34A853" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
              <path fill="#FBBC05" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
            </svg>
            Sign in with Google
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b px-6 py-3 flex justify-between items-center">
        <div className="flex gap-4 items-center">
          <h1 className="text-xl font-bold"><Link to="/">Death Star</Link></h1>
          <nav className="flex gap-3 text-sm">
            <Link to="/repos" className="text-gray-600 hover:text-gray-900">Repos</Link>
            <Link to="/scorecard" className="text-gray-600 hover:text-gray-900">Scorecard</Link>
            <Link to="/cost" className="text-gray-600 hover:text-gray-900">Cost</Link>
            <Link to="/digest" className="text-gray-600 hover:text-gray-900">Digest</Link>
            <Link to="/policy-versions" className="text-gray-600 hover:text-gray-900">Policies</Link>
            <Link to="/suppressions" className="text-gray-600 hover:text-gray-900">Suppressions</Link>
          </nav>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-sm text-gray-600">{email}</span>
          <button onClick={signOut} className="text-sm text-blue-600 hover:underline">Sign out</button>
        </div>
      </header>
      <main className="p-6">
        <Routes>
          <Route path="/" element={<VelocityScorecard />} />
          <Route path="/repos" element={<RepoOverview />} />
          <Route path="/repos/:org/:repo" element={<RepoDashboard />} />
          <Route path="/repos/:org/:repo/pr/:pr" element={<PrDetail />} />
          <Route path="/scorecard" element={<VelocityScorecard />} />
          <Route path="/cost" element={<CostView />} />
          <Route path="/digest" element={<WeeklyDigest />} />
          <Route path="/policy-versions" element={<PolicyVersions />} />
          <Route path="/suppressions" element={<Suppressions />} />
        </Routes>
      </main>
    </div>
  );
}
